<template>
  <a-modal
    title="设备材料清单"
    :visible="dialogState"
    width="68%"
    class="diaBody"
    :ok-button-props="{
      style: btnShow > 6 ? { display: 'none' } : { display: 'inline-block' },
    }"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <el-alert
      title="本订单合同价格为标准配置价格，不限于施工过程中材料数量的减少和增加。（除另有说明外）"
      type="warning"
      show-icon
      style="margin-bottom: 10px"
    >
    </el-alert>
    <p>设备清单</p>
    <a-table
      :columns="columns"
      :data-source="data"
      bordered
      :pagination="false"
      :scroll="{ y: 240 }"
    >
      <template
        v-for="col in ['name', 'model', 'brand', 'count', 'unit']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            placeholder="请输入名称"
            v-if="col == 'name'"
            style="margin: -5px 0"
            v-model.trim="record.name"
            :value="text"
          />
          <a-input
            placeholder="请输入型号"
            v-if="col == 'model'"
            style="margin: -5px 0"
            v-model.trim="record.model"
            :value="text"
          />
          <a-input
            placeholder="请输入数量"
            v-if="col == 'count'"
            style="margin: -5px 0"
            v-model.trim="record.count"
            :value="text"
          />
          <a-input
            placeholder="请输入单位"
            v-if="col == 'unit'"
            style="margin: -5px 0"
            v-model.trim="record.unit"
            :value="text"
          />
          <a-input
            placeholder="请输入品牌"
            v-if="col == 'brand'"
            style="margin: -5px 0"
            v-model.trim="record.brand"
            :value="text"
          />
          <!-- <template v-else>
          {{ text }}
        </template> -->
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button
              class="btnStyle"
              type="primary"
              @click="() => addItem(record.key, 1)"
              :disabled="btnShow > 6"
              >新增</a-button
            >
            <a-button
              class="btnStyle"
              v-show="data.length !== 1"
              :disabled="btnShow > 6"
              type="danger"
              @click="() => deleteItem(record.key, 1, record.id)"
              >删除</a-button
            >
          </span>
        </div>
      </template>
    </a-table>

    <p style="margin-top: 10px">材料清单</p>
    <a-table
      :columns="mColumns"
      :data-source="mdata"
      bordered
      :scroll="{ y: 240 }"
      :pagination="false"
    >
      <template
        v-for="col in ['name', 'model', 'brand', 'count', 'unit']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            placeholder="请输入名称"
            v-if="col == 'name'"
            style="margin: -5px 0"
            v-model.trim="record.name"
            :value="text"
          />
          <a-input
            placeholder="请输入型号"
            v-if="col == 'model'"
            style="margin: -5px 0"
            v-model.trim="record.model"
            :value="text"
          />
          <a-input
            placeholder="请输入数量"
            v-if="col == 'count'"
            style="margin: -5px 0"
            v-model.trim="record.count"
            :value="text"
          />
          <a-input
            placeholder="请输入单位"
            v-if="col == 'unit'"
            style="margin: -5px 0"
            v-model.trim="record.unit"
            :value="text"
          />
          <a-input
            placeholder="请输入品牌"
            v-if="col == 'brand'"
            style="margin: -5px 0"
            v-model.trim="record.brand"
            :value="text"
          />
          <!-- <template v-else>
          {{ text }}
        </template> -->
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button
              class="btnStyle"
              type="primary"
              @click="() => addItem(record.key, 2)"
              :disabled="btnShow > 6"
              >新增</a-button
            >
            <a-button
              class="btnStyle"
              v-show="mdata.length !== 1"
              type="danger"
              :disabled="btnShow > 6"
              @click="() => deleteItem(record.key, 2, record.id)"
              >删除</a-button
            >
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import {
  getEquipment,
  getShopIdFacility,
  getOrderDetail,
} from "@/service/order.js";
import loginVue from "../../views/login.vue";
// 设备
const columns = [
  {
    title: "设备名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "型号",
    dataIndex: "model",
    scopedSlots: { customRender: "model" },
  },
  {
    title: "数量",
    dataIndex: "count",
    scopedSlots: { customRender: "count" },
  },
  {
    title: "单位",
    dataIndex: "unit",
    scopedSlots: { customRender: "unit" },
  },
  {
    title: "品牌",
    dataIndex: "brand",
    scopedSlots: { customRender: "brand" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    width: "18%",
    scopedSlots: { customRender: "operation" },
  },
];
const data = [];
data.push({
  key: data.length,
  brand: "",
  count: "",
  model: "",
  name: "",
  unit: "",
  workOrNo: "No",
});

//材料
const mColumns = [
  {
    title: "材料名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "型号",
    dataIndex: "model",
    scopedSlots: { customRender: "model" },
  },
  {
    title: "数量",
    dataIndex: "count",
    scopedSlots: { customRender: "count" },
  },
  {
    title: "单位",
    dataIndex: "unit",
    scopedSlots: { customRender: "unit" },
  },
  {
    title: "品牌",
    dataIndex: "brand",
    scopedSlots: { customRender: "brand" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    width: "18%",
    scopedSlots: { customRender: "operation" },
  },
];
const mdata = [];
mdata.push({
  key: data.length,
  brand: "",
  count: "",
  model: "",
  name: "",
  unit: "",
  workOrNo: "No",
});
export default {
  props: {
    // dialogState: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    this.cacheData = data.map((item) => ({ ...item }));
    return {
      //   visible: false,
      confirmLoading: false,
      btnShow: "",
      key: 0,
      data: [
        {
          key: 0,
          brand: "",
          count: "",
          model: "",
          name: "",
          unit: "",
          type: 1,
          workOrNo: "No",
        },
      ],
      editData: {},
      examinSata: 1,
      columns,
      editingKey: "",
      dialogState: false,
      mdata: [
        {
          key: 0,
          brand: "",
          count: "",
          model: "",
          name: "",
          type: 2,
          unit: "",
          workOrNo: "No",
        },
      ],
      mColumns,
    };
  },
  mounted() {},
  methods: {
    showModal(data) {
      // console.log("有没有值", data);
      this.dialogState = true;

      if (data) {
        this.editData = data;
        this.getTableData();
        this.getTaskDetail(this.editData.rowOrderId);
        // console.log("编辑材料", data);
      }
    },

    //新建工程编辑回显数据
    showEditData(data, mdata) {
      this.dialogState = true;
      this.data = data;
      this.mdata = mdata;
    },
    //获取详情
    getTaskDetail(id) {
      getOrderDetail({
        order_id: id,
      }).then((res) => {
        if (res.flag) {
          this.btnShow = res.data.status;

          // console.log("详情", res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //新建工程根据选择的商品获取对应的设备材料
    showAddModal(data) {
      // console.log("商品规格弹窗", data);
      this.dialogState = true;
      getShopIdFacility({
        spec_id: data,
      }).then((res) => {
        if (res.flag) {
          // console.log("商品设备材料", res.data);
          if (res.data.equipmentList.length == 0) {
            this.data = [
              {
                key: 0,
                brand: "",
                count: "",
                model: "",
                name: "",
                unit: "",
                type: 1,
                workOrNo: "No",
              },
            ];
          } else {
            this.data = res.data.equipmentList;
          }
          if (res.data.materialList.length == 0) {
            this.mdata = [
              {
                key: 0,
                brand: "",
                count: "",
                model: "",
                name: "",
                type: 2,
                unit: "",
                workOrNo: "No",
              },
            ];
          } else {
            this.mdata = res.data.materialList;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //审核记录设备材料弹窗)
    showExaminDia(data, id) {
      // console.log('id', id);
      // console.log('data', data);
      this.getTaskDetail(id.order_id);
      // this.btnShow = data.status
      this.dialogState = true;
      this.examinSata = 2;
      if (data.equipmentList.length == 0) {
        this.data = [
          {
            key: 0,
            brand: "",
            count: "",
            model: "",
            name: "",
            unit: "",
            type: 1,
            workOrNo: "No",
          },
        ];
      } else {
        this.data = data.equipmentList;
      }
      if (data.materialList.length == 0) {
        this.mdata = [
          {
            key: 0,
            brand: "",
            count: "",
            model: "",
            name: "",
            type: 2,
            unit: "",
            workOrNo: "No",
          },
        ];
      } else {
        this.mdata = data.materialList;
      }
      // this.data = data.equipmentList;
      // this.mdata = data.materialList;
    },
    //确然按钮
    handleOk(e) {
      // console.log("表格数据设备", this.data);
      // console.log("表格数据材料", this.mdata);
      let num = 0;
      let mnum = 0;
      let arr = ["name", "count", "unit"];
      // let count =
      //   this.data.length * arr.length + this.mdata.length * arr.length;
      let dataCount = this.data.length * arr.length;
      let mdataCount = this.mdata.length * arr.length;
      if (this.data.length) {
        this.data.forEach((item) => {
          for (let i = 0; i < arr.length; i++) {
            // console.log(arr[i]);
            if (item[arr[i]]) {
              num++;
            }
          }
        });
      }
      if (this.mdata.length) {
        this.mdata.forEach((item) => {
          for (let i = 0; i < arr.length; i++) {
            // console.log(arr[i]);
            if (item[arr[i]]) {
              mnum++;
            }
          }
        });
      }

      // console.log("num", num);
      // console.log("mnum", mnum);

      if (dataCount !== num && num)
        return this.$message.warning(
          "设备名称、数量和单位为必填项，请正确输入"
        );

      if (mdataCount !== mnum && mnum)
        return this.$message.warning(
          "材料名称、数量和单位为必填项，请正确输入"
        );

      if (this.editData.editStatus == "edit" || this.examinSata == 2) {
        // console.log("编辑的时候走这个");
        this.$emit("editPassData", this.data, this.mdata);
        this.dialogState = false;
        this.examinSata = 1;
      } else {
        // console.log("新增的时候走这个");
        this.$emit("passData", this.data, this.mdata);
        this.dialogState = false;
      }

      // this.confirmLoading = true;
      // this.dialogState = false;
      // // this.$emit("closeDialog", false);
      // setTimeout(() => {
      //   this.visible = false;
      //   this.confirmLoading = false;
      // }, 2000);
    },
    //取消
    handleCancel(e) {
      this.dialogState = false;
      this.editData = {};
      this.$emit("closeDialog", false);
    },

    //获取数据
    getTableData() {
      getEquipment({ order_id: this.editData.rowOrderId }).then((res) => {
        if (res.flag) {
          // console.log("表格", res.data);
          if (res.data.equipmentList.length == 0) {
            this.data = [
              {
                key: 0,
                brand: "",
                count: "",
                model: "",
                name: "",
                unit: "",
                type: 1,
                workOrNo: "No",
              },
            ];
          } else {
            this.data = res.data.equipmentList;
            this.data.forEach((item, index) => {
              item.key = index;
            });
          }
          if (res.data.materialList.length == 0) {
            this.mdata = [
              {
                key: 0,
                brand: "",
                count: "",
                model: "",
                name: "",
                type: 2,
                unit: "",
                workOrNo: "No",
              },
            ];
          } else {
            this.mdata = res.data.materialList;
            this.mdata.forEach((item, index) => {
              item.key = index;
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //添加
    addItem(key, type) {
      // console.log(key);
      if (type == 1) {
        this.data.splice(key + 1, 0, {
          key: "",
          brand: "",
          count: "",
          model: "",
          name: "",
          unit: "",
          type: 1,
          workOrNo: "No",
        });
        this.data.forEach((item, index) => {
          item.key = index;
        });
      } else {
        this.mdata.splice(key + 1, 0, {
          key: "",
          brand: "",
          count: "",
          model: "",
          name: "",
          type: 2,
          unit: "",
          workOrNo: "No",
        });
        this.mdata.forEach((item, index) => {
          item.key = index;
        });
      }

      //   alert(
      //     "所有的数据直接收集到data里面了，查看vue工具可以看收集的数据，给后台传参数的时候把这个数据处理一下，转换为后台需要的格式"
      //   );
    },
    //删除
    deleteItem(key, type, id) {
      if (type == 1) {
        if (this.data.length === 1) {
          return;
        }
        if (key) {
          this.data.splice(key, 1);
          this.data.forEach((item, index) => {
            item.key = index;
          });
        } else {
          this.data.some((item, i) => {
            if (item.id == id) {
              this.data.splice(i, 1);
              return true; //当内部return true时跳出整个循环
            }
          });
        }
      } else {
        if (this.mdata.length === 1) {
          return;
        }
        if (key) {
          this.mdata.splice(key, 1);
          this.mdata.forEach((item, index) => {
            item.key = index;
          });
        } else {
          this.mdata.some((item, i) => {
            if (item.id == id) {
              this.mdata.splice(i, 1);
              return true; //当内部return true时跳出整个循环
            }
          });
        }
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.editable-row-operations a {
  margin-right: 8px;
}
.editable-row-operations >>> .btnStyle {
  margin-bottom: 10px;
}
.diaBody >>> .ant-modal-body {
  padding-top: 10px !important;
  height: 550px;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/equmate/index.vue